var VariableVersion = /** @class */ (function () {
    function VariableVersion() {
    }
    VariableVersion.variableVersion = 29;
    return VariableVersion;
}());
export { VariableVersion };
